/**
 * @generated SignedSource<<ea27cbde6b9879e93876762fbc8f1bd8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type src_workManagementBoard_JWMBoardRoot_queryFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"src_workManagementBoard_BoardWithWorkflowsData_queryFragment">;
  readonly " $fragmentType": "src_workManagementBoard_JWMBoardRoot_queryFragment";
};
export type src_workManagementBoard_JWMBoardRoot_queryFragment$key = {
  readonly " $data"?: src_workManagementBoard_JWMBoardRoot_queryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"src_workManagementBoard_JWMBoardRoot_queryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "src_workManagementBoard_JWMBoardRoot_queryFragment",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "src_workManagementBoard_BoardWithWorkflowsData_queryFragment"
    }
  ],
  "type": "Query"
};

(node as any).hash = "041f3363f5d1940b88332677bca352b5";

export default node;
